import React from "react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {StatePopupWrapperBox} from "./boxes/state-popup-wrapper.box";
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {CyClass} from "../../../common/cy-classes";
import { ModalDialogActionsComponent } from "../modal-dialog/modal-dialog-actions.component";
import { DialogTextBox } from "../modal-dialog/boxes/text/dialog-text.box";

interface IStatePopupComponentProps {
    onStateSelect: () => any;
    dialogHandler: IModalDialogHandler;
    onStateNotInListClick?: () => any;
    headerText?: string;
    stateName: string;
}

export class StatePopupComponent extends OrbitComponent<IStatePopupComponentProps> {

    private _onStateSelector = () => {
        this.services.analytics.sendAnalytics('Client_Message', 'Confirm_Location_Click', 'APPROVE');
        this.props.onStateSelect();
        this._closeDialogBox();
    };

    private _onStateNotInListClick = () => {
        this.services.analytics.sendAnalytics('Client_Message', 'Confirm_Location_Click', 'OUTSIDE_ONTARIO_LINK');
        this.props.onStateNotInListClick();
        this._closeDialogBox();
    };

    private _closeDialogBox = () => {
        this.props.dialogHandler && this.props.dialogHandler.close();
    };

    render() {

        const {headerText, onStateNotInListClick, stateName} = this.props;

        return (
            <StatePopupWrapperBox>
                {headerText && <DialogTextBox>{headerText}</DialogTextBox>}

                <ModalDialogActionsComponent primaryAction={{
                    text: this.services.translation.translate("STATE_POPUP_CONFIRM"),
                    onClick: this._onStateSelector,
                    className: CyClass('cy-state-select-approve-button')
                }} linkAction={onStateNotInListClick && {
                    onClick: this._onStateNotInListClick,
                    text: this.services.translation.translate("STATE_POPUP_OUTSIDE_TEXT", {THE_STATE: stateName})
                }} />
            </StatePopupWrapperBox>
        );
    }
}
